/* eslint-disable @typescript-eslint/no-explicit-any */

import { TFunction } from 'i18next';
import { TPartnerConfigurationDetails } from 'typings/partner';
import { DEFAULT_TRANSLATIONS } from '../../utils/translationFunctions';

// returns the config and accepts an optional translation function
export const getConfig = (t?: TFunction): TPartnerConfigurationDetails => {
  // Use either the passed translation function or default to build-time values
  const translations = DEFAULT_TRANSLATIONS.instaview;

  // Handle translation with fallbacks to build-time defaults
  const translate = (
    key: string,
    options?: object,
    fallback?: string
  ): string => {
    if (t) {
      try {
        const translation = t(key, options as any);
        return translation !== key
          ? translation
          : fallback || translations[key as keyof typeof translations] || key;
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error);
        return (
          fallback || translations[key as keyof typeof translations] || key
        );
      }
    }
    return translations[key as keyof typeof translations] || fallback || key;
  };

  return {
    nameOfCompany: 'HomiQ',
    typeOfCompany: 'Inc.',
    singinLabel: translate('signIn', undefined, 'Sign In') as string,
    welcomeText: translate(
      'welcomeText',
      {
        partnerName: 'HomiQ'
      },
      'Welcome to HomiQ'
    ) as string,
    // loginIllustration: partnerAssets.loginIllustration,
    // logo: InstavisionLogo,
    // logo: partnerAssets.logo,
    // paymentSuccessfull: partnerAssets.paymentSuccessfulIcon,
    // paymentFailed: partnerAssets.paymentFailedIcon,
    // multiCameraAddedIllustration: partnerAssets.AllCamerasAddedToAccountIcon,
    // cannotAddDeviceIcon: partnerAssets.CannotAddSelectedCameraIcon,
    // trialActivationIcon: partnerAssets.FreeTrialActivatedIcon,
    label: 'HomiQ',
    supportEmail: 'support@homiq.life',
    supportEmail2: 'support@homiq.life',
    phoneNumber: '+1 (877) 414-6647',
    companyAddress: '2244 Faraday Avenue, Carlsbad, CA 92008',
    // freeTrialLivingRoom: EventVideos30Days,
    // freeTrialPersonDetected: partnerAssets.descriptiveAIAlertsImg,
    // freeTrialCriticalAlerts: partnerAssets.professionalMonitoringImg,
    // skipFreeTrialLivingRoom: partnerAssets.noEventVideosImg,
    // skipFreeTrialTheft: partnerAssets.limitedSecurityImg,
    // skipFreeTrialFalseAlerts: partnerAssets.basicMotionAlertsImg,
    updateDeteOfPrivacyPolicy: 'July 09, 2024',
    updateDeteOfTermsOfService: 'July 10, 2024',
    // smallWhiteLogo: partnerAssets.logo,

    iosAppLink: 'https://apps.apple.com/app/id6747379728',
    androidAppLink:
      'https://play.google.com/store/apps/details?id=life.homiq.homesecurity'
  };
};

// Export a static config for bundling/tree-shaking
const homiqConfig = getConfig();
export default homiqConfig;
